import { Component } from '@angular/core';

/**
 * Page with title and the community list tree, as described in community-list.component;
 * navigated to with community-list.page.routing.module
 */
@Component({
  selector: 'ds-community-list-page',
  templateUrl: './community-list-page.component.html',
})
export class CommunityListPageComponent {

}
